const map = {
	"./Global/Common/CodeEditable.razor.js": "./Components/Global/Common/CodeEditable.razor.js",
	"./Global/Dialogs/ConfirmDialog.razor.js": "./Components/Global/Dialogs/ConfirmDialog.razor.js",
	"./Global/Dialogs/TextEditDialog.razor.js": "./Components/Global/Dialogs/TextEditDialog.razor.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Components sync recursive ^.*\\.razor\\.js$";